import { render, staticRenderFns } from "./supply-disposal.vue?vue&type=template&id=f40d07ec&"
import script from "./supply-disposal.vue?vue&type=script&lang=js&"
export * from "./supply-disposal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports